// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2xYhb","inner":"Footer_inner__2DV7v","nextIcon":"Footer_nextIcon__2Wcm9","innerLeft":"Footer_innerLeft__3Zepf"};